import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import {LaddaModule} from 'angular2-ladda';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { PipesModule } from '../../../pipes/pipes.module';
import { ComponentModule } from '../../../components/components.module';
import { A48PrintReportStates } from './a48-print-reports.states';
import { A48PrintParaReportComponent } from './a48-para-print-report/a48-para-print-report.component';
import { EdlCommonComponentsModule, EdlCommonDirectiveModule, EdlCommonPipesModule, EdlDatePickerModule } from '@edl-development/edl-common';
import { ComplyDirectivesModule } from 'src/app/directives/comply-directives.module';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({
            states: A48PrintReportStates
        }),
        FormsModule,
        ReactiveFormsModule,
        EdlCommonDirectiveModule,
        ComplyDirectivesModule,
        LaddaModule,
        NgbModule,
        EdlCommonPipesModule,
        PipesModule,
        ComponentModule,
        EdlCommonComponentsModule,
        EdlDatePickerModule
    ],
    declarations: [
        A48PrintParaReportComponent
    ]
})
export class A48PrintReportsModule {}